import React from 'react';
import { Link } from 'react-router-dom';
import { Layout, Menu as AntdMenu, Row } from 'antd';

import ROUTES from '@constants/routes';
import { HeaderLogo } from '@atoms';
import { useIsAuthenticated, useAuth, useIsLOCadmin } from '@hooks';

import s from './styles.module.less';

const Menu = () => {
  const { user, signOut } = useAuth();
  const isLOCadmin = useIsLOCadmin();
  const fullName = `${user.firstName} ${user.lastName}`;

  const handleOnSelect = ({ key }) => {
    if (key === ROUTES.LOGOUT) {
      signOut();
    }
  };

  return (
    <AntdMenu mode="horizontal" className={s.menu} onSelect={handleOnSelect} selectedKeys={null}>
      {!isLOCadmin && (
        <AntdMenu.SubMenu title="Settings">
          <AntdMenu.Item key={ROUTES.SETTINGS}>
            <Link to={ROUTES.SETTINGS}>CMS Users</Link>
          </AntdMenu.Item>
          <AntdMenu.Item key={ROUTES.SETTINGS_CIS}>
            <Link to={ROUTES.SETTINGS_CIS}>CIS Users</Link>
          </AntdMenu.Item>
          <AntdMenu.Item key={ROUTES.SETTINGS_STATS_ZONE}>
            <Link to={ROUTES.SETTINGS_STATS_ZONE}>Stats Zone Users</Link>
          </AntdMenu.Item>
          <AntdMenu.Item key={ROUTES.SETTINGS_MEDAL_CEREMONY}>
            <Link to={ROUTES.SETTINGS_MEDAL_CEREMONY}>Medal Ceremony Users</Link>
          </AntdMenu.Item>
        </AntdMenu.SubMenu>
      )}
      <AntdMenu.SubMenu title={fullName}>
        <AntdMenu.Item key={ROUTES.MY_ACCOUNT}>
          <Link to={ROUTES.MY_ACCOUNT}>My account</Link>
        </AntdMenu.Item>
        <AntdMenu.Item key={ROUTES.LOGOUT}>Sign out</AntdMenu.Item>
      </AntdMenu.SubMenu>
    </AntdMenu>
  );
};

const Header = () => {
  const isAuthenticated = useIsAuthenticated();

  return (
    <Layout.Header>
      <Row justify="space-between" align="center" style={{ height: '100%' }}>
        <HeaderLogo />
        {isAuthenticated && <Menu />}
      </Row>
    </Layout.Header>
  );
};

export default Header;
